import QnAdCard from "@modules/QuickNews/Cards/QnAdCard";
import QnArticleCard from "@modules/QuickNews/Cards/QnArticleCard";
import { QnEndCard } from "@modules/QuickNews/Cards/QnEndCard";
import { FeedItem } from "@typings/QuickNews";

type FeedRenderProps = {
  card: FeedItem;
  isMobile: boolean;
  nextCard: () => void;
  getOlderArticles: () => void;
  typeIndex: number;
};

export const renderFeedCard = ({
  card,
  isMobile,
  nextCard,
  getOlderArticles,
  typeIndex,
}: FeedRenderProps) => {
  if ("adType" in card)
    return (
      <QnAdCard
        key={card.id}
        item={card}
        onNext={nextCard}
        isMobile={isMobile}
      />
    );
  if ("endCard" in card)
    return (
      <QnEndCard
        key={card.id}
        item={card}
        getOlderArticles={getOlderArticles}
      />
    );
  return (
    <div className="w-full h-full m-auto rounded-3xl overflow-hidden">
      <QnArticleCard item={card} typeIndex={typeIndex} isMobile={isMobile} />
    </div>
  );
};
